import { Service } from '@roc/feature-app-core';

const url = {
  REQUEST_APPRAISAL_PAYMENT:
    '/api/v1/document/formDocument/requestAppraisalPayment',
  INTERNAL_REQUEST_APPRAISAL_PAYMENT: '/nportal/rest/priv/payments/requestAppraisalPaymentExternal',
  FETCH_AMC_PAYMENT_LINK: '/api/v1/loan/internalValuation/getAmcPaymentLink',
  GET_AMC_PAYMENT: '/nportal/rest/priv/payments/getLoanInfoForAMCPayment',
  GET_AMC_BY_ID: '/api/v1/roc-valuation/amcLender/getAmcById'
};

export class TamariskPaymentService extends Service {
  requestAppraisalPayment = (isInternal: boolean, entityId: any, type: string) => {
    return this.get(isInternal ? url.INTERNAL_REQUEST_APPRAISAL_PAYMENT : url.REQUEST_APPRAISAL_PAYMENT, {
      entityId,
      type,
    });
  };

  getAmcPayment = (isInternal: boolean, loanId: any) => {
    return this.get(`${url.FETCH_AMC_PAYMENT_LINK}?loanId=${loanId}`);
  };

  getAmcById(amcId: number) {
    return this.get(url.GET_AMC_BY_ID, { amcId });
  };
}